import gsap from 'gsap'

export const initCursor = () => {
	gsap.set('.cursor', { xPercent: -5, yPercent: -5 })
	const cursor = document.querySelector('.cursor')
	const position = { x: window.innerWidth / 2, y: window.innerHeight / 2 }
	const mouse = { x: position.x, y: position.y }

	window.addEventListener('mousemove', (e) => {
		mouse.x = e.x
		mouse.y = e.y
		gsap.to(cursor, { duration: 0.3, x: mouse.x, y: mouse.y })
	})
}

export const cursorEvents = () => {
	const cursor = document.querySelector('.cursor')
	const next = document.querySelectorAll('.swiper-button-next')
	const prev = document.querySelectorAll('.swiper-button-prev')

	next.forEach((el) => {
		el.addEventListener('mouseover', (e) => cursor.classList.add('cursor--arrow-right'))
		el.addEventListener('mouseout', (e) => cursor.classList.remove('cursor--arrow-right'))
	})

	prev.forEach((el) => {
		el.addEventListener('mouseover', (e) => cursor.classList.add('cursor--arrow-left'))
		el.addEventListener('mouseout', (e) => cursor.classList.remove('cursor--arrow-left'))
	})
}

export default () => {}